import type * as Types from '../../../schemas/shopify/admin.types';

import {
  MarketNodeFragmentDoc,
  MarketWebPresenceEdgesFragmentDoc,
  MarketWebPresenceNodeFragmentDoc,
  MarketWebPresenceRootUrlNodeFragmentDoc,
} from '../fragments/market.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcherGemX } from '../../utils/gatewayClientGemX';
export type MarketsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type MarketsQueryResponse = {
  markets: {
    nodes: Array<
      Pick<Types.Market, 'id' | 'name' | 'handle'> & {
        webPresences: {
          edges: Array<
            Pick<Types.MarketWebPresenceEdge, 'cursor'> & {
              node: { rootUrls: Array<Pick<Types.MarketWebPresenceRootUrl, 'url' | 'locale'>> };
            }
          >;
        };
      }
    >;
  };
};

export const MarketsDocument = `
    query Markets {
  markets(first: 250) {
    nodes {
      ...MarketNode
    }
  }
}
    ${MarketNodeFragmentDoc}
${MarketWebPresenceEdgesFragmentDoc}
${MarketWebPresenceNodeFragmentDoc}
${MarketWebPresenceRootUrlNodeFragmentDoc}`;

export const useMarketsQuery = <TData = MarketsQueryResponse, TError = unknown>(
  variables?: MarketsQueryVariables,
  options?: UseQueryOptions<MarketsQueryResponse, TError, TData>,
) => {
  return useQuery<MarketsQueryResponse, TError, TData>(
    variables === undefined ? ['Markets'] : ['Markets', variables],
    appFetcherGemX<MarketsQueryResponse, MarketsQueryVariables>(MarketsDocument, variables),
    options,
  );
};

useMarketsQuery.getKey = (variables?: MarketsQueryVariables) =>
  variables === undefined ? ['Markets'] : ['Markets', variables];
